import arrow_back_ios_new from "../../assets/Images/arrow_back_ios_new.png";
import "./SubscriptionManagement.css"; // Import your CSS file for animations
import { useNavigate } from "react-router-dom";
import { useFintechLayouts } from "../../services/AsaApiServices";
import { useIsFetching, useIsMutating } from "react-query";
import LoaderComponent from "../../components/LoaderComponent";
import { useTranslation } from "react-i18next";
const SubscriptionManagementBase = ({
  children,
  ...props
}: {
  children: React.ReactNode;
  [key: string]: any;
}) => {
  const { t,i18n } = useTranslation();
  const navigate = useNavigate();
  const fintechLaoyut = useFintechLayouts(); // getLayoutFromFintech(fintech);
  const fintechIcon = fintechLaoyut?.icon ?? ""; // Fallback for icon
  const appName = fintechLaoyut?.appName ?? "Guac";

  const isFetching = useIsFetching();
  const isMutating = useIsMutating();
  // Handling Update Session Error
  const isLoading = isFetching > 0 || isMutating > 0;
  const { onNavigateBack } = props;
  const handleBackClick = () => {
  
    if (onNavigateBack) {
      onNavigateBack();
    } else {
      navigate(-1);
    }
  }
  return (
    <div className="flex justify-center items-center h-screen min-w-[384px]">
      {isLoading && <LoaderComponent />}
      <div
        className="w-full h-full flex flex-col bg-gradient-guac text-white relative z-20"
        style={fintechLaoyut?.backGroundStyle}
      >
        <div className="flex flex-row items-center  p-4 z-50"
         
        >
            <img
              alt="back"
              className="flex cursor-pointer p-2 shadow-2xl rounded-lg w-10 h-10"
              src={arrow_back_ios_new}
              onClick={handleBackClick}
            />
            <span className="flex text-white font-poppins text-base font-semibold leading-normal"
              onClick={handleBackClick}
            >
              {t("return")}
            </span>
        </div>

        <div className="dark:bg-[#121212] bg-[#EBECF0] dark:text-white text-[#4E4E4E] flex-grow relative rounded-t-3xl mt-6 p-4 flex flex-col">
          <div className="flex justify-center  -mt-20 ">
            <img alt={appName ?? "Asa "} src={fintechIcon}  className="object-contain w-[85px] h-[85px] rounded-xl"/>
          </div>

          <div className="flex flex-col mb-6 mt-2 items-center">
            <span className="uppercase dark:text-white text-[#4E4E4E] text-center font-poppins text-lg font-semibold leading-5 tracking-[-0.1px]">
              {appName ?? "Asa "}
            </span>
          </div>

          {children}
        </div>
      </div>
    </div>
  );
};

export default SubscriptionManagementBase;
